upstack.controller('openingCtrl', ['$filter', '$http', '$sce', '$timeout', function($filter, $http, $sce, $timeout){
	var vm = this;
	vm.loading = true;
    vm.jobs = [];

    vm.search = location.search.substring(1);
    vm.query = JSON.parse('{"' + decodeURI(vm.search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}');

    $http.get('https://upstack.co/api/v1/job-openings/' + vm.query.uid).then(function(response){
        vm.loading = false;
        vm.job = response.data;
    });

	vm.close = function(){
	    vm.jobData = undefined;
	};
	
}]);

$(function(){
    var url = document.location.href;
    if(url.includes('opening') && url.includes('uid')) {
        var offset = $('.job-wrapper').offset().top;
        $(document).scrollTop(offset);
    }
});
